/**
 * Timeout Constants
 * 
 * Centralized timeout values for consistent behavior across the application.
 * All values are in milliseconds.
 * 
 * This file is the source of truth for timeout values. The no-hardcoded-ports
 * rule is disabled here since these are timeout values, not port numbers.
 * 
 * @module @/core/constants/timeouts
 */

 

/**
 * UI/UX Timeouts
 */
export const UI_TIMEOUTS = {
  /** Toast notification auto-dismiss delay */
  TOAST_DISMISS: 5000,
  /** Loading state timeout before showing error */
  LOADING_TIMEOUT: 5000,
  /** Session fetch timeout for chat components */
  SESSION_FETCH: 10000,
  /** Debounce delay for streaming updates */
  STREAMING_DEBOUNCE: 50,
} as const;

/**
 * API/Network Timeouts
 */
export const API_TIMEOUTS = {
  /** Default API request timeout */
  DEFAULT: 30000,
  /** Short API timeout for quick operations */
  SHORT: 5000,
  /** Medium API timeout for standard operations */
  MEDIUM: 10000,
  /** Long API timeout for complex operations */
  LONG: 15000,
  /** Session creation timeout */
  SESSION_CREATE: 15000,
} as const;

/**
 * Rate Limiting Windows
 */
export const RATE_LIMIT_WINDOWS = {
  /** Standard rate limit window (1 minute) */
  STANDARD: 60000,
  /** Short rate limit window (15 seconds) */
  SHORT: 15000,
} as const;

/**
 * Content/Data Limits
 */
export const CONTENT_LIMITS = {
  /** Maximum content length for document processing (~500KB) */
  MAX_DOCUMENT_LENGTH: 500000,
} as const;

